import gql from 'graphql-tag';

const GET_CURRICULUMS = gql`
  query getCurriculums($subject: String!, $section: String, $subsection: String, $clientContext: String) {
    curriculumChoices(subject: $subject, section: $section, subsection: $subsection, clientContext: $clientContext)
  }
`;

export default GET_CURRICULUMS;
